import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropType from 'prop-types';
import ColorBar from './ColorBar';
import { Wrap, Title } from './styled';

function Colors({ active, setColor, list, colorsMapping }) {
  return (
    <Wrap>
      <Title>
        <FormattedMessage id="product.title.color" />
        {colorsMapping.get(active) || active}
      </Title>
      <ColorBar active={active} onChange={setColor} colorSet={list} />
    </Wrap>
  );
}

export default Colors;

Colors.propTypes = {
  list: PropType.arrayOf(PropType.any).isRequired,
  active: PropType.string.isRequired,
  setColor: PropType.func.isRequired,
  colorsMapping: PropType.instanceOf(Map).isRequired,
};
